import React from 'react'

import { Drawer as MuiDrawer, makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  frame: {
    width: '85%',
  },
})

export const Drawer = (props: any) => {
  const { anchor = 'right', open, children, ...rest } = props
  const classes = useStyles()

  return (
    <MuiDrawer
      {...rest}
      classes={{ paper: classes.frame }}
      anchor={anchor}
      open={open}
    >
      {children}
    </MuiDrawer>
  )
}
